import React from 'react'
import { GoChevronDown, GoSearch } from "react-icons/go";
import { AiOutlineShoppingCart } from "react-icons/ai";

import './input.css'
const ProductSchesuleInput = () => {
  return (
    <div className='schedule-input'>
       <div className="selectinput1">
          <select name="" id="">
            <option value=""></option>
            <option value="">option1</option>
            <option value="">option1</option>
          </select>
       </div>
       <div className="selectinput2">
           <input type="text" />
           <AiOutlineShoppingCart className='cart'/>
       </div>
       <div className="selectinput3">
           <input type="text" />
           <GoSearch className='Gosearch'/>
       </div>
    </div>

  )
}

export default ProductSchesuleInput